
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.936 2.47a.75.75 0 011.061 1.06L3.811 9.717H18a.75.75 0 010 1.5H3.81l6.187 6.186a.75.75 0 01-1.06 1.06L1.47 10.998a.748.748 0 010-1.06L8.936 2.47z"}})])
          )
        }
      }
    